<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">
                    {{amenitiesService.quoteModalObject.amenityName}} Booking Request Submitted
                </h4>
            </div>
            <div class="modal-body">
                <div *ngIf="step == 'offer'">
                    <div *ngIf="amenitiesService.quoteModalType == 'elevator'">
                        <div class="proposal-text">
                            Thanks for submitting the request to book the {{amenitiesService.quoteModalObject.amenityName}}.
                            Management will review your request and respond with approval shortly. In the meanwhile, we can
                            shop around for you for the best quotes from local moving companies. <br>
                            Click below if you'd like to see the best rate we can get.
                        </div>
                        <div class="row text-center space-30 buttons-row">
                            <button type="submit"
                                    class="btn btn-outer-primary mtv-primary-color mtv-primary-border"
                                    [disabled]="disabledSubmit"
                                    (click)="goToCancelQuestionary()">
                                No Thanks
                            </button>
                            <button type="submit"
                                    class="btn btn-primary"
                                    [disabled]="disabledSubmit"
                                    (click)="getQuote()">
                                Show Me the Rate
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="step == 'cancelled'">
                    <h4>OK, no problem. We understand you are not interested. Can you tell us why?</h4>
                    <div *ngFor="let answer of answers">
                        <label class="img-checkbox">
                            <input type="checkbox" id="{{answer.id}}" [(ngModel)]="answer.checked">
                            <label for="{{answer.id}}"><svg-checked></svg-checked></label>
                            <span>{{answer.answer}}</span>
                        </label>
                        <br *ngIf="answer.id == '5' && answer.checked">
                        <textarea *ngIf="answer.id == '5' && answer.checked" [(ngModel)]="otherReason"></textarea>
                    </div>
                    <div class="row text-center space-30 buttons-row">
                        <button type="submit"
                                class="btn btn-outer-primary mtv-primary-color mtv-primary-border"
                                [disabled]="disabledSubmit"
                                (click)="goBackToOffer()">
                            Back
                        </button>
                        <button type="submit"
                                class="btn btn-primary"
                                [disabled]="disabledSubmit"
                                (click)="sendRejectReason()">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            <spinner [spinnerShow]="false"></spinner>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenity-quotes-modal/amenities-quotes-modal.component.html